import gql from 'graphql-tag';
import { useMutation } from '@apollo/react-hooks';
import {
  DeprecateFacebookLeadgenFormsMutation,
  DeprecateFacebookLeadgenFormsMutationVariables
} from './__generated__/DeprecateFacebookLeadgenFormsMutation';
import { kmsClient } from '../../apollo';

const DEPRECATE_FACEBOOK_LEADGEN_FORMS_JOB_MUTATION = gql`
  mutation DeprecateFacebookLeadgenFormsMutation($ids: [ID!]!) {
    createJobsFacebookLeadgenFormsDeprecateJob(ids: $ids) {
      jobsFacebookLeadgenFormsMutateJob {
        id
        status
      }
      errors
    }
  }
`;

export const useDeprecateFacebookLeadgenFormsJobMutation = () => {
  return useMutation<DeprecateFacebookLeadgenFormsMutation, DeprecateFacebookLeadgenFormsMutationVariables>(
    DEPRECATE_FACEBOOK_LEADGEN_FORMS_JOB_MUTATION,
    { client: kmsClient, notifyOnNetworkStatusChange: true }
  );
};
